<div class="orders">
	@if (widget()?.assetClass === assetClassEnum.US_EQUITY) {
		<app-positions-stocks [widget]="widget()" />
	} @else {
		<app-positions-options [widget]="widget()" />
	}
</div>
